var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.MODAL_ID,
        size: "lg",
        centered: "",
        "dialog-class": "resize-template-modal",
        "body-class": "resize-template-modal__body",
        "hide-header": "",
        "hide-backdrop": "",
      },
      on: {
        ok: function ($event) {
          $event.preventDefault()
          return _vm.onSave.apply(null, arguments)
        },
        shown: _vm.onShown,
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel, ok }) {
            return [
              _c(
                "div",
                { staticClass: "resize-template-modal__footer" },
                [
                  _c(
                    "b-button",
                    { attrs: { variant: "link" }, on: { click: cancel } },
                    [_vm._v("\n        Cancel\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "primary",
                        disabled: !_vm.selectedSizes.length || _vm.isSaving,
                      },
                      on: { click: ok },
                    },
                    [
                      _vm.isSaving
                        ? _c("span", {
                            staticClass: "spinner-border spinner-border-sm",
                            attrs: { role: "status", "aria-hidden": "true" },
                          })
                        : _c("b-icon", { attrs: { icon: "stars" } }),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.submitButtonLabel) +
                          "\n      "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.progress.total > 0
                ? _c(
                    "div",
                    { staticClass: "mt-4 w-100" },
                    [
                      _c("ProgressBarComponent", {
                        attrs: {
                          total: _vm.progress.total,
                          current: _vm.progress.current,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "div",
        { staticClass: "resize-template-modal__header" },
        [
          _c("div", [
            _c("h5", [_vm._v(_vm._s(_vm.title))]),
            _vm._v(" "),
            _vm.selectedTemplateSize
              ? _c(
                  "div",
                  { staticClass: "resize-template-modal__original-size" },
                  [
                    _vm._v(
                      "\n        Original " +
                        _vm._s(_vm.formattedSelectedTemplateSize) +
                        "\n      "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("b-button-close", {
            attrs: { "aria-label": "Close" },
            on: { click: _vm.onClose },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "resize-template-modal__content" }, [
        _vm.selectedSizes.length
          ? _c(
              "section",
              { staticClass: "resize-template-modal__selected-sizes" },
              [
                _c(
                  "div",
                  { staticClass: "resize-template-modal__section-heading" },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.isMultiSizes ? "New sizes" : "New size")
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        attrs: { type: "button" },
                        on: { click: _vm.clearSelectedSizes },
                      },
                      [_vm._v("\n          Clear all\n        ")]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "resize-template-modal__chips" },
                  _vm._l(_vm.selectedSizes, function (size, index) {
                    return _c(
                      "button",
                      {
                        key: size.template
                          ? `template-${size.template.id}`
                          : `${size.width}-${size.height}-${index}`,
                        staticClass: "resize-template-modal__chip",
                        attrs: {
                          type: "button",
                          title: size.template
                            ? `Mapped to ${size.template.name}`
                            : "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onRemoveSize(index)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(size.width) +
                            " × " +
                            _vm._s(size.height) +
                            "\n          "
                        ),
                        _c("b-icon", { attrs: { icon: "x" } }),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "resize-template-modal__tabs",
            attrs: { role: "tablist" },
          },
          _vm._l(_vm.RESIZE_TABS, function (tab) {
            return _c(
              "button",
              {
                key: tab.id,
                class: { active: _vm.activeTab === tab.id },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.selectTab(tab.id)
                  },
                },
              },
              [
                _c("b-icon", { attrs: { icon: tab.icon } }),
                _vm._v("\n        " + _vm._s(tab.label) + "\n      "),
              ],
              1
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "resize-template-modal__picker" },
          [
            _vm.activeTab === _vm.TAB_TYPES.PRESETS
              ? [
                  _c(
                    "div",
                    { staticClass: "resize-template-modal__search" },
                    [
                      _c("b-icon", { attrs: { icon: "search" } }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.presetSearch,
                            expression: "presetSearch",
                            modifiers: { trim: true },
                          },
                        ],
                        attrs: {
                          type: "search",
                          placeholder: "Search size or name...",
                        },
                        domProps: { value: _vm.presetSearch },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.presetSearch = $event.target.value.trim()
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "resize-template-modal__catalog" },
                    [
                      _vm._l(_vm.filteredPresetGroups, function (group) {
                        return _c(
                          "div",
                          {
                            key: group.name,
                            staticClass: "resize-template-modal__preset-group",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "resize-template-modal__group-title",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(group.name) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "resize-template-modal__card-grid",
                              },
                              _vm._l(group.sizes, function (size) {
                                return _c(
                                  "button",
                                  {
                                    key: size.id,
                                    staticClass:
                                      "resize-template-modal__size-card",
                                    class: {
                                      selected: _vm.isSizeSelected(size),
                                    },
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.togglePresetSize(size)
                                      },
                                    },
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "resize-template-modal__size-preview",
                                      style: _vm.getSizePreviewStyle(size),
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "resize-template-modal__card-copy",
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(size.width) +
                                              " × " +
                                              _vm._s(size.height)
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("small", [
                                          _vm._v(_vm._s(size.name)),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.isSizeSelected(size)
                                      ? _c("b-icon", {
                                          attrs: { icon: "check" },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      !_vm.filteredPresetGroups.length
                        ? _c(
                            "div",
                            { staticClass: "resize-template-modal__empty" },
                            [_vm._v("\n            No sizes found\n          ")]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              : _vm.activeTab === _vm.TAB_TYPES.TEMPLATES
              ? [
                  _c(
                    "div",
                    { staticClass: "resize-template-modal__template-toolbar" },
                    [
                      _c(
                        "div",
                        { staticClass: "resize-template-modal__search" },
                        [
                          _c("b-icon", { attrs: { icon: "search" } }),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.templateSearch,
                                expression: "templateSearch",
                                modifiers: { trim: true },
                              },
                            ],
                            attrs: {
                              type: "search",
                              placeholder: "Search templates...",
                            },
                            domProps: { value: _vm.templateSearch },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.templateSearch = $event.target.value.trim()
                              },
                              blur: function ($event) {
                                return _vm.$forceUpdate()
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("Multiselect", {
                        staticClass: "resize-template-modal__customer",
                        attrs: {
                          "track-by": "name",
                          label: "name",
                          placeholder: "Select customer",
                          options: _vm.customerOptions,
                          "show-labels": false,
                        },
                        on: { input: _vm.onChangeCustomer },
                        model: {
                          value: _vm.selectedCustomer,
                          callback: function ($$v) {
                            _vm.selectedCustomer = $$v
                          },
                          expression: "selectedCustomer",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "resize-template-modal__template-filters" },
                    [
                      _c(
                        "div",
                        _vm._l(
                          _vm.TEMPLATE_ORIENTATION_FILTERS,
                          function (filter) {
                            return _c(
                              "button",
                              {
                                key: filter.value,
                                class: {
                                  active:
                                    _vm.selectedTypeTemplate === filter.value,
                                },
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    _vm.selectedTypeTemplate = filter.value
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(filter.label) +
                                    "\n            "
                                ),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-checkbox",
                        {
                          attrs: { switch: "" },
                          model: {
                            value: _vm.galleryView,
                            callback: function ($$v) {
                              _vm.galleryView = $$v
                            },
                            expression: "galleryView",
                          },
                        },
                        [_vm._v("\n            Gallery view\n          ")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "resize-template-modal__template-list",
                      class: { "gallery-view": _vm.galleryView },
                    },
                    [
                      _vm._l(_vm.filteredTemplates, function (template) {
                        return _c(
                          "button",
                          {
                            key: template.id || template.name,
                            staticClass: "resize-template-modal__template-card",
                            class: {
                              selected: _vm.isTemplateSelected(template),
                            },
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.toggleTemplate(template)
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "resize-template-modal__template-size-preview",
                              },
                              [
                                _c("span", {
                                  style: _vm.getSizePreviewStyle(template),
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "resize-template-modal__card-copy",
                              },
                              [
                                _c("strong", [_vm._v(_vm._s(template.name))]),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  [
                                    _vm._v(
                                      _vm._s(template.width) +
                                        " × " +
                                        _vm._s(template.height)
                                    ),
                                    _vm.getTemplateCustomerName(template)
                                      ? [
                                          _vm._v(
                                            " · " +
                                              _vm._s(
                                                _vm.getTemplateCustomerName(
                                                  template
                                                )
                                              )
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isTemplateSelected(template)
                              ? _c("b-icon", { attrs: { icon: "check" } })
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm.isLoading
                        ? _c(
                            "div",
                            { staticClass: "resize-template-modal__empty" },
                            [
                              _vm._v(
                                "\n            Loading templates...\n          "
                              ),
                            ]
                          )
                        : !_vm.selectedCustomer
                        ? _c(
                            "div",
                            { staticClass: "resize-template-modal__empty" },
                            [
                              _vm._v(
                                "\n            Select a customer to browse templates\n          "
                              ),
                            ]
                          )
                        : !_vm.filteredTemplates.length
                        ? _c(
                            "div",
                            { staticClass: "resize-template-modal__empty" },
                            [
                              _vm._v(
                                "\n            No templates found\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              : [
                  _c(
                    "div",
                    { staticClass: "resize-template-modal__custom-size" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "resize-template-modal__custom-preview",
                        },
                        [_c("span", { style: _vm.customSizePreviewStyle })]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "resize-template-modal__custom-controls",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "resize-template-modal__dimensions",
                            },
                            [
                              _c(
                                "label",
                                [
                                  _vm._v(
                                    "\n                Width\n                "
                                  ),
                                  _c("b-form-input", {
                                    ref: "customSizeWidth",
                                    attrs: {
                                      min: "1",
                                      type: "number",
                                      placeholder: "Width",
                                    },
                                    on: {
                                      input: (value) =>
                                        _vm.onCustomSizeChange(
                                          value,
                                          _vm.CUSTOM_SIZE_INPUT_TYPES
                                            .WIDTH_INPUT
                                        ),
                                    },
                                    model: {
                                      value: _vm.customSize.width,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.customSize,
                                          "width",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "customSize.width",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v("×")]),
                              _vm._v(" "),
                              _c(
                                "label",
                                [
                                  _vm._v(
                                    "\n                Height\n                "
                                  ),
                                  _c("b-form-input", {
                                    attrs: {
                                      min: "1",
                                      type: "number",
                                      placeholder: "Height",
                                    },
                                    on: {
                                      input: (value) =>
                                        _vm.onCustomSizeChange(
                                          value,
                                          _vm.CUSTOM_SIZE_INPUT_TYPES
                                            .HEIGHT_INPUT
                                        ),
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        $event.preventDefault()
                                        return _vm.onAddCustomSize()
                                      },
                                    },
                                    model: {
                                      value: _vm.customSize.height,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.customSize,
                                          "height",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "customSize.height",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-checkbox",
                            {
                              attrs: { switch: "" },
                              on: { change: _vm.onMaintainAspectRatioChange },
                              model: {
                                value: _vm.maintainAspectRatio,
                                callback: function ($$v) {
                                  _vm.maintainAspectRatio = $$v
                                },
                                expression: "maintainAspectRatio",
                              },
                            },
                            [
                              _vm._v(
                                "\n              Lock aspect ratio\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "primary",
                            block: "",
                            disabled: !_vm.isCustomSizeValid,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onAddCustomSize()
                            },
                          },
                        },
                        [
                          _c("b-icon", { attrs: { icon: "plus" } }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.customSizeButtonLabel) +
                              "\n          "
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "resize-template-modal__advanced-toggle",
            attrs: {
              type: "button",
              "aria-expanded": _vm.advancedOptionsVisible ? "true" : "false",
            },
            on: {
              click: function ($event) {
                _vm.advancedOptionsVisible = !_vm.advancedOptionsVisible
              },
            },
          },
          [
            _c(
              "span",
              [
                _c("b-icon", { attrs: { icon: "sliders" } }),
                _vm._v(" Advanced options"),
              ],
              1
            ),
            _vm._v(" "),
            _c("b-icon", {
              attrs: {
                icon: _vm.advancedOptionsVisible
                  ? "chevron-up"
                  : "chevron-down",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "section",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.advancedOptionsVisible,
                expression: "advancedOptionsVisible",
              },
            ],
            staticClass: "resize-template-modal__advanced",
          },
          [
            _c("label", [_vm._v("Edit background (optional)")]),
            _vm._v(" "),
            _c("Multiselect", {
              staticClass: "background-dropdown",
              attrs: {
                "track-by": "id",
                label: "name",
                placeholder: "Choose background",
                options: _vm.getBackgroundFields,
              },
              scopedSlots: _vm._u([
                {
                  key: "singleLabel",
                  fn: function (props) {
                    return [
                      _c("div", { staticClass: "background-dropdown-label" }, [
                        _c(
                          "div",
                          { staticClass: "background-dropdown-label__image" },
                          [
                            _c("img", {
                              attrs: {
                                src: props.option.thumbnail,
                                alt: props.option.name,
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "background-dropdown-label__text" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(props.option.name) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "option",
                  fn: function (props) {
                    return [
                      _c("div", { staticClass: "background-dropdown-option" }, [
                        _c(
                          "div",
                          { staticClass: "background-dropdown-option__image" },
                          [
                            _c("img", {
                              attrs: {
                                src: props.option.thumbnail,
                                alt: props.option.name,
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "background-dropdown-option__text" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(props.option.name) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.selectedBackground,
                callback: function ($$v) {
                  _vm.selectedBackground = $$v
                },
                expression: "selectedBackground",
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "resize-template-modal__option-row" },
              [
                _c("span", [
                  _vm._v(
                    "Create a base template on the system with the new size"
                  ),
                ]),
                _vm._v(" "),
                _c("b-form-checkbox", {
                  staticClass: "m-0",
                  attrs: { switch: "" },
                  model: {
                    value: _vm.createBasetemplate,
                    callback: function ($$v) {
                      _vm.createBasetemplate = $$v
                    },
                    expression: "createBasetemplate",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "resize-template-modal__option-row" },
              [
                _c("span", [_vm._v("Auto-position objects")]),
                _vm._v(" "),
                _c("b-form-checkbox", {
                  staticClass: "m-0",
                  attrs: { switch: "" },
                  model: {
                    value: _vm.isAutoPosition,
                    callback: function ($$v) {
                      _vm.isAutoPosition = $$v
                    },
                    expression: "isAutoPosition",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }